
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 19V5a2.006 2.006 0 00-2-2H5a2.006 2.006 0 00-2 2v14a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2zM8.9 13.98l2.1 2.53 3.1-3.99a.5.5 0 01.8.01l3.51 4.68a.5.5 0 01-.4.8H6.02a.5.5 0 01-.39-.81L8.12 14a.493.493 0 01.78-.02z"}})])
          )
        }
      }
    